<template>
  <div class="wrapper plan-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("PLAN") }}</h1>
          <div class="tab-area">
            <div
              class="tab link-over"
              v-on:click="isSelect('1')"
              v-bind:class="{ active: isActive === '1' }"
            >
              BUSINESS
            </div>
            <!-- <div
              class="tab link-over"
              v-on:click="isSelect('2')"
              v-bind:class="{ active: isActive === '2' }"
            >
              INVESTOR
            </div> -->
          </div>
          <div class="balance">
            <h2>{{ $t("Current staking") }}</h2>
            <div class="total-amount"><span>100</span> USD</div>
          </div>
          <div class="rate-box">
            <div class="now-rate">
              現在の購入レート&nbsp;&nbsp;<span>000</span>USDT 〜 <span>000</span>USDT
            </div>
            <div class="rate-txt link-over">
              <router-link to="./rate" class="link-over"><span>?</span>レートについてはこちら</router-link>
            </div>
          </div>
          <div class="tab-contents" v-show="isActive === '1'">
            <div class="form">
              <form action="">
                <div class="input-area">
                  <input type="radio" name="plan" id="clear" checked />
                  <label for="clear" class="link-over">
                    {{ $t("Clear") }}<span>$ 200</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan1" />
                  <label for="plan1" class="link-over bronze">
                    {{ $t("Bronze") }}<span>$ 500</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan2" />
                  <label for="plan2" class="link-over silver">
                    {{ $t("Silver") }}<span>$ 2000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan3" />
                  <label for="plan3" class="link-over gold">
                    {{ $t("Gold") }}<span>$ 10000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan4" />
                  <label for="plan4" class="link-over ruby">
                    {{ $t("Ruby") }}<span>$ 30000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan5" />
                  <label for="plan5" class="link-over sapphire">
                    {{ $t("Sapphire") }}<span>$ 50000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan6" />
                  <label for="plan6" class="link-over emerald">
                    {{ $t("Emerald") }}<span>$ 100000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan7" />
                  <label for="plan7" class="link-over diamond">
                    {{ $t("Diamond") }}<span>$ 500000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan15" />
                  <label for="plan15" class="link-over other">
                    {{ $t("Custom plan") }}
                    <div
                      class="circle"
                      v-bind:class="{
                        active: hasPlanAmount,
                      }"
                    >
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                    <div class="hidden-form">
                      <input
                        type="text"
                        name=""
                        v-bind="amountPlan"
                        :placeholder="$t('Enter the purchase amount')"
                      />
                    </div>
                  </label>
                </div>
                <div class="form-btn">
                  <button type="button" class="link-over" v-on:click="show2">
                    {{ $t("Purchase") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="tab-contents" v-show="isActive === '2'">
            <div class="form">
              <form action="">
                <div class="input-area">
                  <input type="radio" name="plan" id="plan8" checked />
                  <label for="plan8" class="link-over bronze">
                    {{ $t("Bronze") }}<span>$ 500</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan9" />
                  <label for="plan9" class="link-over silver">
                    {{ $t("Silver") }}<span>$ 2000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan10" />
                  <label for="plan10" class="link-over gold">
                    {{ $t("Gold") }}<span>$ 10000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan11" />
                  <label for="plan11" class="link-over ruby">
                    {{ $t("Ruby") }}<span>$ 30000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan12" />
                  <label for="plan12" class="link-over sapphire">
                    {{ $t("Sapphire") }}<span>$ 50000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan13" />
                  <label for="plan13" class="link-over emerald">
                    {{ $t("Emerald") }}<span>$ 100000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan14" />
                  <label for="plan14" class="link-over diamond">
                    {{ $t("Diamond") }}<span>$ 500000</span>
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                  </label>
                </div>
                <div class="input-area">
                  <input type="radio" name="plan" id="plan16" />
                  <label for="plan16" class="link-over other">
                    {{ $t("Custom plan") }}
                    <div class="circle">
                      <img src="../assets/img/check-icon-img.png" />
                    </div>
                    <div class="hidden-form">
                      <input
                        type="text"
                        name=""
                        :placeholder="$t('Enter the purchase amount')"
                      />
                    </div>
                  </label>
                </div>
                <div class="form-btn">
                  <button type="button" class="link-over" v-on:click="show2">
                    {{ $t("Purchase") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="table">
            <h2>
              {{ $t("Purchase history") }}
              <router-link to="./history" class="link-over">{{
                $t("Details")
              }}</router-link>
            </h2>
            <div class="tab-area">
              <div
                class="tab link-over"
                v-on:click="isSelect2('1')"
                v-bind:class="{ active: isActive2 === '1' }"
              >
                BUSINESS
              </div>
              <!-- <div
                class="tab link-over"
                v-on:click="isSelect2('2')"
                v-bind:class="{ active: isActive2 === '2' }"
              >
                INVESTOR
              </div> -->
            </div>
            <div class="table-wrap" v-show="isActive2 === '1'">
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("PLAN") }}</th>
                  <th>{{ $t("Number of points") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USD</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>RP</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USD</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>RP</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
              </table>
            </div>
            <div class="table-wrap" v-show="isActive2 === '2'">
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("PLAN") }}</th>
                  <th>{{ $t("Number of points") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USD</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>RP</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USD</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>RP</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <modal
      name="planModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <div class="modal-ttl">
          <p>〇〇{{ $t("Are you sure you want to buy?") }}</p>
        </div>
        <div class="btn">
          <button v-on:click="hide" type="button" class="link-over">
            {{ $t("Purchase") }}
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="planModal2"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <div class="modal-ttl">
          <h2>{{ $t("Select a purchase method") }}</h2>
          <div class="modal-form">
            <form action="">
              <div class="input-area">
                <p class="error-txt">
                  {{ $t("Not enough balance") }}
                </p>
                <input type="radio" name="currency" id="currency1" />
                <label for="currency1" class="link-over not">
                  USD<span>{{ $t("BALANCE") }}：100 USD</span>
                  <div class="circle">
                    <img src="../assets/img/check-icon-img.png" />
                  </div>
                </label>
              </div>
              <div class="input-area">
                <input type="radio" name="currency" id="currency2" />
                <label for="currency2" class="link-over">
                  RP<span>{{ $t("BALANCE") }}：100 RP</span>
                  <div class="circle">
                    <img src="../assets/img/check-icon-img.png" />
                  </div>
                </label>
              </div>
              <div class="input-area">
                <input type="radio" name="currency" id="currency3" />
                <label for="currency3" class="link-over">
                  PP<span>{{ $t("BALANCE") }}：100 PP</span>
                  <div class="circle">
                    <img src="../assets/img/check-icon-img.png" />
                  </div>
                </label>
              </div>
              <div class="input-area">
                <input type="radio" name="currency" id="currency4" />
                <label for="currency4" class="link-over">
                  CP<span>{{ $t("BALANCE") }}：100 CP</span>
                  <div class="circle">
                    <img src="../assets/img/check-icon-img.png" />
                  </div>
                </label>
              </div>
              <div class="form-btn">
                <button type="button" class="link-over" v-on:click="isModal">
                  {{ $t("Purchase") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </modal>

    <Footer title="Plan" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Plan",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Plan",
      isActive: "1",
      isActive2: "1",
      amountPlan: "",
    };
  },
  methods: {
    isSelect: function (num) {
      this.isActive = num;
    },
    isSelect2: function (num) {
      this.isActive2 = num;
    },
    isModal: function () {
      this.$modal.hide("planModal2");
      this.$modal.show("planModal");
    },
    show: function () {
      this.$modal.show("planModal");
    },
    hide: function () {
      this.$modal.hide("planModal");
    },
    show2: function () {
      this.$modal.show("planModal2");
    },
    hide2: function () {
      this.$modal.hide("planModal2");
    },
  },
  computed: {
    hasPlanAmount() {
      return this.amountPlan;
    },
  },
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }
  },
};
</script>
